





































import axios from '@/utils/init-axios'
import endpoints from '@/utils/endpoints.js'

import Table from '@/components/Table/Table.vue'
import { Component, Vue } from 'vue-property-decorator'

interface Field {
  name: string
  key: string
  required: boolean
}

@Component({
  components: {
    Table
  }
})
export default class CustomerImport extends Vue {
  fields: Field[] = [
    { name: 'ID', key: 'external_id', required: true },
    { name: 'First Name', key: 'first_name', required: true },
    { name: 'Last Name', key: 'last_name', required: true },
    { name: 'Address', key: 'address', required: true },
    { name: 'City', key: 'city', required: true },
    { name: 'State', key: 'state_province', required: true },
    { name: 'Postal Code', key: 'postal_code', required: true },
    { name: 'E-mail', key: 'email', required: false },
    { name: 'Cell Phone', key: 'cell_phone', required: true },
    { name: 'Amount Due', key: 'amount_due', required: true },
    { name: 'Due Date', key: 'due_date', required: true }
  ]

  data: object = {}
  mappings: object = {}
  merchant_account: string = ''
  headers: string[] = []
  customers: object[] = []

  created() {
    this.$store.dispatch('setPageTitle', { pageTitle: 'Import Customers' })
    this.getMerchantAccounts()

    const csv = this.$store.getters.csvData
    this.headers = csv.meta.fields
    this.customers = csv.data

    // Pull an existing mapping from the local store, if they've done one.
    const existing = localStorage.getItem('mapping')
    if (existing) {
      const mappings = JSON.parse(existing)
      for (const [k, v] of Object.entries(mappings)) {
        const field = v as Field
        const mapping = this.fields.find(e => e.key == field.key)
        if (mapping) {
          this.mappings[k] = mapping
        }
      }
    }
  }

  get items(): string[] {
    return [...this.headers]
  }

  get required(): Set<Field> {
    const required = this.fields.filter(x => x.required)
    return new Set(required)
  }

  get isReady(): boolean {
    const required = this.required
    const mappings = new Set(Object.values(this.mappings))
    const remaining = [...required].filter(x => !mappings.has(x))

    return remaining.length === 0
  }

  checkDisabled(item: string, field: Object) {
    // Disable the option if it's already selected, but not by this column.
    const mappings = new Set(Object.values(this.mappings))
    return mappings.has(field) && this.mappings[item] != field
  }

  handleInput() {
    // TODO: Figure out how to get the bindings correct on the entry options
    //       such that we don't have to do it this way to get the enabled/disabled
    //       options to update on all the other columns when a given column changes.
    this.$forceUpdate()
  }

  submitData() {
    // Get rid of any mappings they switched back after selecting one.
    let selections = Object.fromEntries(
      Object.entries(this.mappings).filter(([_, v]) => v != null)
    )

    // Store the selections locally for the next time they do this.
    localStorage.setItem('mapping', JSON.stringify(selections))

    // Invert those to get the mapping of our key to their column.
    const choices = Object.entries(selections).filter(([_, v]) => v != null)
    const mappings = new Map(choices.map(([k, v]) => [v.key, k]))

    // Iterate over all the customers and call the API to make 'em.
    let payloads: object[] = []
    for (const customer of this.customers) {
      const fn = function(key: string): string {
        const mapping = mappings.get(key)!
        return customer[mapping]
      }

      const date = fn('due_date')
      const due = date ? new Date(Date.parse(date)) : new Date()

      // TODO: Front-end validation and correction of numbers.
      let phone = fn('cell_phone')
      if (phone) {
        phone = '+1' + phone.replace('-', '').replace(' ', '')
      }

      const payload = {
        email: fn('email'),
        first_name: fn('first_name'),
        last_name: fn('last_name'),
        sms_phone_number: phone,
        address: fn('address'),
        city: fn('city'),
        state_province: fn('state_province'),
        postal_code: fn('postal_code'),
        accounts: [
          {
            external_id: fn('external_id'),
            amount_due: fn('amount_due'),
            merchant_account: this.merchant_account,
            due_date: due.toISOString().split('T')[0]
          }
        ]
      }

      payloads.push(payload)
    }

    axios
      .post(endpoints.createCustomer(this.$route.params.merchantID), payloads)
      .then(_ => {
        // If all goes well, send them back to the main list.
        this.$router.push({ name: 'CustomerList' })
      })
      .catch(error => {
        // Otherwise process the errors and display the bad rows.
        this.handleErrors(error.response.data)
      })
  }

  // TODO: Paint the specific rows/columns with the error in question and allow them to fix inline.
  handleErrors(errors: object[]) {
    let remaining: object[] = []
    for (let i = 0; i < errors.length; i++) {
      if (Object.keys(errors[i]).length) {
        remaining.push(this.customers[i])
      }
    }

    this.customers = remaining
  }

  // TODO: Not this
  getMerchantAccounts() {
    this.axios
      .get(endpoints.listMerchantAccounts(this.$route.params.merchantID), {
        params: { page: 1, page_size: 10000 }
      })
      .then(res => {
        const accounts = res.data.results
        if (accounts.length) {
          this.merchant_account = accounts[0].id
        }
      })
      .catch(err => {
        console.log(err)
      })
  }
}
